import Icon from "@ant-design/icons";

const Svg = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3 12L3 14.6667C3 15.0203 3.16389 15.3594 3.45561 15.6095C3.74734 15.8595 4.143 16 4.55556 16L15.4444 16C15.857 16 16.2527 15.8595 16.5444 15.6095C16.8361 15.3594 17 15.0203 17 14.6667V12M7 9L10 12L13 9M10 11L10 3"
        stroke="#1F3C88" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>

  )
}
export const MyIcon = (props: any) => <Icon component={Svg} {...props} />;